<template>
  <div class="nr-panel">
    <div class="nr-panel-title">
      <slot name="header">{{ title }}</slot>
      <span
        class="nr-panel-tagline nr-panel-tagline-small-screens"
        v-if="tagline"
        >{{ tagline }}</span
      >
    </div>
    <div class="nr-panel-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NrPanel',
  props: {
    title: {
      type: String
    },
    tagline: {
      type: String
    }
  }
}
</script>

<style lang="scss">
.nr-panel {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #dddddd;
  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 8px 12px;
    background-color: #f4f4f6;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
  }

  &-tagline {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
  }
  // Small mobile
  @media only screen and (max-width: 320px) {
    &-tagline-small-screens {
      float: left;
    }
    &-title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 16px;
    }
  }
  // Large mobile
  @media only screen and (max-width: 414px) {
    &-title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 16px;
    }
  }
  &-content {
    background-color: white;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
</style>
